import { AssetContext } from '@pages/Asset/Asset.query';
import { getProductValue } from '@utils/getProductValue';
import React, { useContext } from 'react';

import { NoUpdatesText, NoUpdatesContainer } from '../../Updates.styles';

const NoUpdates = () => {
  const { equipmentQuery } = useContext(AssetContext);

  const equipment = equipmentQuery?.data;
  const productData = getProductValue(equipment);

  let text = 'There are no new updates';
  if (productData.model) {
    text = text.concat(` for ${productData.model}`);
  }
  if (productData.manufacturerName) {
    const manufacturerSection = `. As ${productData.manufacturerName} sends new ones, they will appear here`;
    text = text.concat(manufacturerSection);
  }

  return (
    <NoUpdatesContainer>
      <NoUpdatesText>{text}.</NoUpdatesText>
    </NoUpdatesContainer>
  );
};

export { NoUpdates };
